import React, { useEffect, useMemo } from "react";
import { RowFlex, Add } from "./style";
import Button from "../../../components/FormElement/Button";
import { PlusOutlined } from "@ant-design/icons";
import Form from "./Form";
import CustomPagination from "../../../components/FormElement/Pagination";
import { useShowModal, useHideModal } from "../../../hooks";
import DeleteModal from "../../../components/DeleteModal";
import service from "../../../services/services";
import { useState } from "react";
import { useShowAlert } from "../../../hooks/useAlerts";
import ServiceCard from "../../../components/Cards/ServiceCard";
import Spinner from "../../../components/Spinner/FullScreen";

function Service() {
  const { showBlured } = useShowModal();
  const { hideModal } = useHideModal();
  const [loading, setLoading] = useState(false);
  const { error } = useShowAlert();
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
  });
  const [total, setTotal] = useState(0);
  const [data, setData] = useState([]);

  const pageQuery = useMemo(
    () => (pagination.page ? `page=${pagination.page}` : " "),
    [pagination.page]
  );
  const limitQuery = useMemo(
    () => (pagination.limit ? `&limit=${pagination.limit}` : ""),
    [pagination.limit]
  );
  const query = useMemo(
    () => `${pageQuery}${limitQuery}`,
    [pageQuery, limitQuery]
  );

  const fetchData = async () => {
    setLoading(true);
    try {
      const result = await service.getAllPaginate(query);
      const finalResult = result.rows.map((item, idx) => ({
        ...item,
        img: item.logo,
        index: pagination.page * pagination.limit - pagination.limit + idx + 1,
      }));
      setData(finalResult);
      setTotal(result.count);
    } catch (err) {
      console.log(err);
      error(
        "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [query]);

  const handleShowModal = () => {
    showBlured({
      title: "Ma'lumotlarni kiriting",
      maxWidth: "400px",
      maxHeight: "400px",
      withHeader: false,
      body: () => <Form refreshData={fetchData} />,
    });
  };
  const handleDel = (id) => {
    setLoading(true);
    service
      .delete(id)
      .then(() => {
        fetchData();
        hideModal();
      })
      .catch((err) => {
        console.log(err);
        error(
          "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const handleDelete = (id) => {
    showBlured({
      title: "",
      maxWidth: "400px",
      height: "400px",
      withHeader: false,
      body: () => <DeleteModal onClick={() => handleDel(id)} />,
    });
  };
  const handleEdit = (data) => {
    showBlured({
      title: "Tahrirlash",
      maxWidth: "400px",
      maxHeight: "400px",
      withHeader: false,
      body: () => <Form edit={data?.id} refreshData={fetchData} />,
    });
  };

  const handleChangePagination = (pageNumber) => {
    setPagination((prev) => ({ ...prev, page: pageNumber }));
  };

  if (loading) return <Spinner />;
  return (
    <div>
      <Add>
        <Button
          text="Qo'shish"
          icon={<PlusOutlined />}
          onClick={handleShowModal}
        />
      </Add>
      <RowFlex>
        {data.map((item) => (
          <div className="card" key={item.id}>
            <ServiceCard
              onDelete={handleDelete}
              onEdit={handleEdit}
              data={item}
            />
          </div>
        ))}
      </RowFlex>
      {total > 10 && (
        <CustomPagination
          align="end"
          total={total}
          onChange={handleChangePagination}
          defaultPageSize={pagination.limit}
          defaultCurrent={pagination.page}
        />
      )}
    </div>
  );
}

export default Service;
